import type {MigrationInterface, QueryRunner} from "typeorm";

export class AddEntitlementField1737750000000 implements MigrationInterface {
  name = "AddEntitlementField1737750000000";

  async up(queryRunner: QueryRunner): Promise<void> {
    try {
      // Check if the entitlement column already exists
      const table = await queryRunner.getTable("user");
      if (!table) {
        console.error("User table not found during migration");
        return;
      }

      const hasEntitlementColumn = table.columns.find((column) => column.name === "entitlement");

      if (!hasEntitlementColumn) {
        console.log("Adding entitlement column to user table");
        await queryRunner.query(`ALTER TABLE "user" ADD COLUMN "entitlement" text`);
        console.log("Entitlement column added successfully");
      } else {
        console.log("Entitlement column already exists, skipping");
      }
    } catch (error) {
      console.error("Error adding entitlement column:", error);
      // Don't throw - allow migration to continue
    }
  }

  async down(queryRunner: QueryRunner): Promise<void> {
    try {
      const table = await queryRunner.getTable("user");
      if (table) {
        const hasEntitlementColumn = table.columns.find((column) => column.name === "entitlement");
        if (hasEntitlementColumn) {
          await queryRunner.query(`ALTER TABLE "user" DROP COLUMN "entitlement"`);
        }
      }
    } catch (error) {
      console.error("Error removing entitlement column:", error);
    }
  }
}
